import { IRigRateRange } from '../../interfaces/irig-rate-range';
import { Rig } from '../rig';

export class RigRateRangeBase {
  RigRateRangeId: number;
  RigId: number;
  OilPriceMin: number | null;
  OilPriceMax: number | null;
  Rate: number | null;
  Comments: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Rig?: Rig;

  constructor(item?: IRigRateRange) {
    if (item) {

      this.RigRateRangeId = item.RigRateRangeId;
      this.RigId = item.RigId;
      this.OilPriceMin = item.OilPriceMin;
      this.OilPriceMax = item.OilPriceMax;
      this.Rate = item.Rate;
      this.Comments = item.Comments;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Rig = new Rig(item.Rig);
    }
  }
}